import api from '@swipekit/lib/api.js';

const state = {
	items: [],
};

const getters = {
	all: function (state) {
		return state.items;
	},
};

const actions = {
	async refresh(store, params) {
		const items = await api.generations.load(params);
		store.commit('SET_ITEMS', items || []);
		return items;
	},

	async loadMore(store, params) {
		const items = await api.generations.load(params);
		if (items) store.commit('APPEND_ITEMS', items);
		return items;
	},

	async get(store, id) {
		return await api.generations.get(id);
	},

	async afterLogout(store) {
		store.commit('SET_ITEMS', []);
	},
};

const mutations = {
	SET_ITEMS: function (state, items) {
		state.items = items;
	},
	APPEND_ITEMS: function (state, items) {
		state.items = state.items.concat(items);
	},
};

export default { namespaced: true, state, getters, actions, mutations };
